import { ROUTE_PATH as GIFT_SET_PATH } from '@/features/giftSetsPage/consts';

export const createEditGiftSetLink = giftSetId =>
  `${GIFT_SET_PATH}/${giftSetId}/edit`;
